const ACCESS_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJkYXRhIjp7ImlhdCI6MTc2NTIxODQwOCwiZXhwIjoxNzY1MjE4NDY4LCJ1c2VyX2lkIjoiMSIsInJvbGVfaWQiOiIxIiwicm9sZV9uYW1lIjoiU3VwZXItQWRtaW4iLCJ1c2VybmFtZSI6InJvb3QifX0.yVO_rx5wSqH0o4cF7RzJzxs8Y4pPq_SCZMg0xyadKrc';

const apiHost = 'http://apintinda.pesarates.com/';

export default {

    async loginUser(username, password) {

        let data = {
            "username": username,
            "password": password,
        }
        try {
            let response = await fetch(apiHost + 'login', //'user/login',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data),
                });
            let result = await response.json();

            //console.log("llllllllllllllllll",result,"hjhhj",data)

            return result;
        } catch (error) {
            console.log(error)
            let connError = { 'status': 'conn', 'details': { 'message': 'Contacting server....', 'content': false } }
             //console.log("mmmmmmmmmmmmmmmmmmm",error)
            return connError;
        }

    },

        async sendMail(phone, email, date, fullname, service, doctor, message) {

        let data = {
            "phone": phone,
            "email": email,
            "date": date,
            "fullname": fullname,
            "service": service,
            "doctor": doctor,
            "message": message
        }
        try {
            let response = await fetch(apiHost + 'send_mail', //'user/login',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data),
                });
            let result = await response.json();

            //console.log("llllllllllllllllll",result,"hjhhj",data)

            return result;
        } catch (error) {
            console.log(error)
            let connError = { 'status': 'conn', 'details': { 'message': 'Contacting server....', 'content': false } }
             //console.log("mmmmmmmmmmmmmmmmmmm",error)
            return connError;
        }

    },


}